<ul *ngIf="collapsed && data.items && data.items.length > 0"

  [@submenu]="expanded
  
  ? {value: 'visible',
  
      params:{transitionParams:'400ms cubic-bezier(0.86, 0,0.07,1)',height :'*'}}
  
  : {value: 'hidden',
  
  params:{transitionParams:'400ms cubic-bezier(0.86, 0,0.07,1)',height :'0'}}"
  
  class="sublevel-nav">
    <li *ngFor="let item of data.items" class="sublevel-nav-item">
      <a class="sublevel-nav-link" (click)="handleClick(item)" *ngIf="item.items && item.items.length > 0">
        <!-- <i class="sublevel-link-icon fa fa-circle" ></i> -->
        <span class="sublevel-link-text" @fadeInOut>{{item.label}}</span>
        <i *ngIf="item.items && collapsed" class="menu-collapse-icon" [ngClass]="item.expanded ? 'fa fa-angle-down' : 'fa fa-angle-right'"
        ></i>
      </a>
       <a class="sublevel-nav-link" (click)="createTabsFromNavbarData(item)"
        *ngIf="!item.items || (item.items && item.items.length == 0)">
        <!-- <i class="sublevel-link-icon fa fa-circle"></i> -->
        <span class="sublevel-link-text" @fadeInOut *ngIf="collapsed"  data-bs-toggle="tooltip" data-bs-placement="right" title="{{ item.label}}">{{item.label}}</span>

      </a> 
      <!-- <div *ngIf="item.items && item.items.length > 0">
        <app-sublevel-menu [data]="item" [multiple]="multiple"
        [collapsed]="collapsed" [expanded]="item.expanded"></app-sublevel-menu>
      </div> -->
    </li>
  </ul>